import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import strings from '../../components/locales/';
import moment from 'moment';

/* Function */
import ObjGeneral from '../function/';
import Constants from '../function/constants.js';
/* Local store */
import { localStoreFN } from '../../store/localStorage';
/* Actions */
import * as summaryFfdSleepActions from '../../actions/summary_ffd_sleep/index';
import * as summaryFfdPvtActions from '../../actions/summary_ffd_pvt/index';
import * as dashboardActions from '../../actions/dashboard/index.js';
import * as workingShiftGroupsActions from '../../actions/common/working_shift_groups/index';
import * as headerActions from '../../actions/header/index.js';

/* Components */
import { Tooltip } from 'react-bootstrap';
import Header from '../../components/summary_ffd_sleep/header';
import Main from '../../components/summary_ffd_sleep/main';
import Buttons from '../../components/summary_ffd_sleep/buttons';
import ButtonsTop from '../../components/summary_ffd_sleep/buttonsTop';
import Table from '../../components/summary_ffd_sleep/table';

import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import Expired from '../expired/index';

import tourConfig from '../../components/common/tour/config';
import tourStepsResults from '../../components/summary_ffd_sleep/tourStepsResults';
import tourStepsSync from '../../components/summary_ffd_sleep/tourStepsSync';

class SummaryFfdSleep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pag: 1,
      select: '',
      concatBPM: false,
      datosBPM: {},
      sort: {
        alias: null,
        risk: 'DESC',
        evolution: null,
        distribution: null,
        ndrivers: null,
        ninRisk: null
      },
      firstOpenResults: true,
      firstOpenSync: true,
      isTourOpenResults: null,
      isTourOpenSync: null
    };
  }

  async componentDidMount() {
    // get the permissions to validate the view
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('ffdsleep');
    if (permit) {
      if (this.props.setting) {
        // get the setting objects
        const obj = JSON.parse(this.props.setting.value);
        if (obj.generalSetting.views.includes('ffdsleep')) {
          if(this.props.redirectPvt) {
            this.props.history.push('/dashboard/summary_ffd_pvt');  
          }
          let main;
          let groupMain;
          main = obj.generalSetting.main;
          groupMain = obj.generalSetting.groupMainInSummary ? 
            obj.generalSetting.groupMainInSummary : false;

          // we bring the persisted data
          const dateStart = this.props.filters.date.fechaStartFinal || null;
          const dateEnd = this.props.filters.date.fechaEndFinal || null;
          let mainPers = this.props.filters.main || main;
          const tags = this.props.filters.tags;
          const reportType = this.props.filters.reportType;
          const workingShiftGroup = this.props.filters.workingShiftGroup || null;
          
          if(this.props.filters.main==null && groupMain) {
            this.setState({ select: 1 });
            mainPers = "WorkingShiftGroup;1";  
          }
          else if(this.props.filters.main==null && !groupMain) {
            this.setState({ select: mainPers });
            mainPers = "Tag;" + mainPers.toUpperCase();          
          }
          else {
            this.setState({ select: mainPers.split(";")[1].toLowerCase() });
          }

          // eslint-disable-next-line react/no-did-mount-set-state
          await this.props.workingShiftGroupsActions.fetchWorkingShiftGroupsApi();

          this.props.actions.setFilterSummaryFfdSleep({
            date: this.props.filters.date,
            tags: this.props.filters.tags,
            main: mainPers,
            reportType: this.props.filters.reportType,
            workingShiftGroup: workingShiftGroup
          },"loading");

          // call to Form's fetch api
          await this.props.actions.fetchSummaryFfdSleepTableApi({
            main: mainPers,
            dateStart,
            dateEnd,
            tags,
            reportType,
            workingShiftGroup,
            pag: this.state.pag,
            sort: this.state.sort
          });
          await this.props.actions.fetchSummaryFfdSleepTableCountApi({
            main: mainPers,
            dateStart,
            dateEnd,
            tags,
            reportType,
            workingShiftGroup
          });
          await this.props.actions.fetchSummaryFfdSleepApi({
            main: mainPers,
            dateStart,
            dateEnd,
            tags,
            reportType,
            workingShiftGroup,            
            sort: this.state.sort,
          });
          if(this.props.filters.reportType=="FFDResult") {
            this.props.headerActions.setRepeatTourAction(this.openTourResults);
          }
          else {
            this.props.headerActions.setRepeatTourAction(this.openTourSync);
          }
          // COUNT fetch api call
        } else {
          // not authorized
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      // not authorized
      this.props.history.push('/dashboard/authorization');
    }
  }

  openTourResults = () => {
    this.setState({
      isTourOpenResults: true
    });
  };  

  openTourSync = () => {
    this.setState({
      isTourOpenSync: true
    });
  };  

  closeTourResults = async () => {
    const viewedTours = localStoreFN().getItem('viewedTours');
    const tourComplete = viewedTours ? JSON.parse(viewedTours)[Constants.toursKeys.summarySleepResults] : false;
    if(tourComplete==false) {
      await this.props.dashboardActions.setTourViewed({tourName:Constants.toursKeys.summarySleepResults});
    }

    this.setState({
      isTourOpenResults: false
    });
  };  

  closeTourSync = async () => {
    const viewedTours = localStoreFN().getItem('viewedTours');
    const tourComplete = viewedTours ? JSON.parse(viewedTours)[Constants.toursKeys.summarySleepSync] : false;
    if(tourComplete==false) {
      await this.props.dashboardActions.setTourViewed({tourName:Constants.toursKeys.summarySleepSync});
    }

    this.setState({
      isTourOpenSync: false
    });
  };  

  //Manage redux state changes
  async componentDidUpdate(prevProps,prevState) {
    if(!this.props.loading && !this.props.loadingTable 
      && !this.props.loadingFilter && !this.props.loadingCount
      && this.props.status === 200 && this.props.statusTags === 200
      && this.props.statusTable === 200 && this.props.statusCount === 200
      && this.props.filters.reportType=="FFDResult"
      && this.state.firstOpenResults==true) {
      const viewedTours = localStoreFN().getItem('viewedTours');
      const tourComplete = viewedTours ? JSON.parse(viewedTours)[Constants.toursKeys.summarySleepResults] : false;
      // loading of the tour results when the view just entered
      this.state.firstOpenResults = false;
      if(tourComplete==false) {
        this.state.isTourOpenResults = true;
        tourConfig.openTourJsCall(tourStepsResults, this.closeTourResults, this.props.language, ".main-container.scroll");
      }
      else {
        this.state.isTourOpenResults = false;
      }
    }
  
    // loading result tour when called afterwards
    if(prevState.isTourOpenResults==false && this.state.isTourOpenResults==true
      && this.props.filters.reportType=="FFDResult") {
      tourConfig.openTourJsCall(tourStepsResults, this.closeTourResults, this.props.language, ".main-container.scroll");
    }

    if(!this.props.loading && !this.props.loadingTable 
      && !this.props.loadingFilter && !this.props.loadingCount
      && this.props.status === 200 && this.props.statusTags === 200
      && this.props.statusTable === 200 && this.props.statusCount === 200
      && this.props.filters.reportType=="FFDSync"
      && this.state.firstOpenSync==true) {
      const viewedTours = localStoreFN().getItem('viewedTours');
      const tourComplete = viewedTours ? JSON.parse(viewedTours)[Constants.toursKeys.summarySleepSync] : false;
      // loading of the tour carried out when the view just entered
      this.state.firstOpenSync = false;
      if(tourComplete==false) {
        this.state.isTourOpenSync = true;
        tourConfig.openTourJsCall(tourStepsSync, this.closeTourSync, this.props.language, ".main-container.scroll");
      }
      else {
        this.state.isTourOpenSync = false;
      }
    }

    // loading of the realization tour when called later
    if(prevState.isTourOpenSync==false && this.state.isTourOpenSync==true
      && this.props.filters.reportType=="FFDSync") {
      tourConfig.openTourJsCall(tourStepsSync, this.closeTourSync, this.props.language, ".main-container.scroll");
    }

    if((prevProps.loadingTable == true 
      && this.props.loadingTable == false
      && this.props.statusTable === 200) ||
      (prevProps.loadingTableSpiner == true 
      && this.props.loadingTableSpiner == false
      && this.props.statusTable === 200)) {
        var hola = this.props.datosTable.filter(item => {
            if(this.state.concatBPM==true 
              && item.key in (this.state.datosBPM)) {
              return false;
            }
            return true;
          }).map(item => {
            return item.key;
          });
        await this.props.actions.fetchSummaryFfdSleepBPMApi({
          concat:this.state.concatBPM,
          dateStart: this.props.filters.date.fechaStartFinal,
          dateEnd: this.props.filters.date.fechaEndFinal,
          main: this.props.filters.main,
          tags: this.props.filters.tags,
          reportType: this.props.filters.reportType,
          workingShiftGroup: this.props.filters.workingShiftGroup,
          tableDataKeys: this.props.datosTable.filter(item => {
            if(this.state.concatBPM==true 
              && item.key in (this.state.datosBPM)) {
              return false;
            }
            return true;
          }).map(item => {
            return item.key;
          })
        });
        this.state.concatBPM = false;
    }
  
    if(prevProps.loadingBPM == true 
      && this.props.loadingBPM == false
      && this.props.statusBPM === 200) {
        this.state.datosBPM = {};
        this.props.datosBPM.map(item => {
          this.state.datosBPM[item.key]=item.response;
        });
        this.setState({
          datosBPM: this.state.datosBPM
        });
    }
  }

  // we load the reset function, return the states to their initial state
  componentWillUnmount() {
    this.props.actions.resetSummaryFfdSleep();
    this.props.headerActions.resetHeader();
  }

  // function performed to sort the table
  handleSort = async event => {
    /* Change sort */
    const sort = { ...this.state.sort };
    if (event.currentTarget.dataset.type === 'alias') {
      sort.risk = null;
      sort.evolution = null;
      sort.distribution = null;
      sort.ndrivers = null;
      sort.ninRisk = null;
    } else if (event.currentTarget.dataset.type === 'risk') {
      sort.alias = null;
      sort.evolution = null;
      sort.distribution = null;
      sort.ndrivers = null;
      sort.ninRisk = null;
    } else if (event.currentTarget.dataset.type === 'evolution') {
      sort.alias = null;
      sort.risk = null;
      sort.distribution = null;
      sort.ndrivers = null;
      sort.ninRisk = null;
    } else if (event.currentTarget.dataset.type === 'distribution') {
      sort.alias = null;
      sort.risk = null;
      sort.evolution = null;
      sort.ndrivers = null;
      sort.ninRisk = null;
    } else if (event.currentTarget.dataset.type === 'ndrivers') {
      sort.alias = null;
      sort.risk = null;
      sort.evolution = null;
      sort.distribution = null;
      sort.ninRisk = null;
    } else if (event.currentTarget.dataset.type === 'ninRisk') {
      sort.alias = null;
      sort.risk = null;
      sort.evolution = null;
      sort.distribution = null;
      sort.ndrivers = null;
    }
    const value = this.state.sort[event.currentTarget.dataset.type] == 'DESC' ? 'ASC' : 'DESC';
    sort[event.currentTarget.dataset.type] = value;

    const objDate = JSON.parse(this.props.setting.value);
    const format = this.props.language.account.date.format;
    const date = ObjGeneral.getDate({ id: null }, format);

    this.setState({
      sort
    });

    this.setState({ pag: 1 });

    await this.props.actions.fetchSummaryFfdSleepTableNoLoadingApi({
      sort,
      pag: 1,
      main: this.props.filters.main,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      reportType: this.props.filters.reportType,
      tags: this.props.filters.tags,
      workingShiftGroup: this.props.filters.workingShiftGroup
    });
  };

  handleSubmit = async obj => {
    const group = this.props.filters.main;
    const objDate = JSON.parse(this.props.setting.value);
    const format = this.props.language.account.date.format;
    const tags = ObjGeneral.getTags(obj);
    const date = ObjGeneral.getDate(obj, format);
    const workingShiftGroup = ObjGeneral.getWorkingShiftGroup(obj);
    let reportType = ObjGeneral.getReportType(obj);
    
    reportType = (reportType == null ? 
      this.props.filters.reportType : reportType);
    
    this.setState({ pag: 1 });

    if(ObjGeneral.compareDateString(date.fechaEndFinal,date.fechaStartFinal)<0) {
      date.fechaStartFinal = ObjGeneral.addDaysToDateString(
        date.fechaEndFinal,-1*objDate.ffd.defaultRangeInDay);
      setTimeout(function(){
        document.getElementById('date-start').value = 
          moment(date.fechaStartFinal, 'YYYY-MM-DD').format(format);
        }, 1)
    }

    this.state.datosBPM = {};

    if(reportType=="FFDResult") {
      this.props.headerActions.setRepeatTourAction(this.openTourResults);
    }
    else {
      this.props.headerActions.setRepeatTourAction(this.openTourSync);
    }
    
    // set filter to persist
    this.props.actions.setFilterSummaryFfdSleep({
      date,
      tags: tags,
      main: group,
      reportType: reportType,
      workingShiftGroup: workingShiftGroup
    },"loading");
    /* Fetch */
    await this.props.actions.fetchSummaryFfdSleepTableCountApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      main: group,
      pag: 1,
      tags: tags,
      reportType: reportType,
      workingShiftGroup: workingShiftGroup
    });
    await this.props.actions.fetchSummaryFfdSleepTableApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      main: group,
      sort: this.state.sort,
      tags: tags,
      pag: 1,
      reportType: reportType,
      workingShiftGroup: workingShiftGroup
    });
    await this.props.actions.fetchSummaryFfdSleepApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      main: group,
      sort: this.state.sort,
      tags: tags,
      pag: 1,
      reportType: reportType,
      workingShiftGroup: workingShiftGroup
    });
  };

  // function made to filter only table
  handleSubmitTable = async obj => {
    /* Get Select */
    const group = obj.currentTarget.dataset.select;
    const groupType = obj.currentTarget.dataset.category;
    const main = groupType + ";" + group.toUpperCase();
    /* Get Date */
    const objDate = JSON.parse(this.props.setting.value);
    const format = this.props.language.account.date.format;
    const tags = ObjGeneral.getTags(obj);
    const date = ObjGeneral.getDate(obj, format);
    /* Set Pag */
    this.setState({ pag: 1 });

    this.state.datosBPM = {};

    // set filter to persist
    this.props.actions.setFilterSummaryFfdSleep({
      date,
      tags: tags,
      main: main,
      reportType: this.props.filters.reportType,
      workingShiftGroup: this.props.filters.workingShiftGroup
    },"loadingTable");
    /* Fetch */
    await this.props.actions.fetchSummaryFfdSleepTableCountApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      main: main,
      pag: 1,
      tags: tags,
      reportType: this.props.filters.reportType,
      workingShiftGroup: this.props.filters.workingShiftGroup
    });
    await this.props.actions.fetchSummaryFfdSleepTableApi({
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      main: main,
      sort: this.state.sort,
      tags: tags,
      pag: 1,
      reportType: this.props.filters.reportType,
      workingShiftGroup: this.props.filters.workingShiftGroup
    });
    this.setState({ select: group });
  };

  // function performed to paginate
  handleScroll = async event => {
    if (!event.target.dataset.nonescroll 
      && !this.state.isTourOpenResults && !this.state.isTourOpenSync) {
      if (!this.props.loadingTableSpiner) {
        if (this.state.pag < this.props.count.pages) {
          const scroll = event.target.scrollTop;
          const max = event.target.scrollHeight - event.target.offsetHeight;
          if (scroll >= max) {
            /* Change Pag */
            this.setState({
              pag: this.state.pag + 1
            });
            const pag = this.state.pag + 1;
            /* Get Date */
            const objDate = JSON.parse(this.props.setting.value);
            const format = this.props.language.account.date.format;
            const date = ObjGeneral.getDate({ id: null }, format);
            /* Fetch */
            this.state.concatBPM = true;
            await this.props.actions.fetchSummaryFfdSleepTableNoLoadingApi({
              pag,
              concat: true,
              main: this.props.filters.main,
              dateStart: date.fechaStartFinal,
              dateEnd: date.fechaEndFinal,
              reportType: this.props.filters.reportType,
              workingShiftGroup: this.props.filters.workingShiftGroup,
              sort: this.state.sort,
              tags: this.props.filters.tags,
            });
          }
        }
      }
    }
  };

  handleSubmitChangeFfdType = obj => {
    this.props.ffdPvtActions.setFilterSummaryFfdPvt({
      date: this.props.filters.date,
      tags: this.props.filters.tags,
      main: this.props.filters.main,
      reportType: this.props.filters.reportType.replace("FFDSync","FFDRealization"),
      workingShiftGroup: this.props.filters.workingShiftGroup
    });
    this.props.ffdPvtActions.setActiveStateSummaryFfdPvt({
      active:true
    });
    this.props.history.push('/dashboard/summary_ffd_pvt');
  };

  handleDownloadExcelSummary = async obj => {
    await this.props.actions.downloadSummaryReport({
      dateStart: this.props.filters.date.fechaStartFinal,
      dateEnd: this.props.filters.date.fechaEndFinal,
      main: this.props.filters.main,
      sort: this.state.sort,
      tags: this.props.filters.tags,
      reportType: this.props.filters.reportType,
      workingShiftGroup: this.props.filters.workingShiftGroup
    });
  };

  handleDownloadExcelNoProcess = async obj => {
    await this.props.actions.downloadNoProcessReport({
      dateStart: this.props.filters.date.fechaStartFinal,
      dateEnd: this.props.filters.date.fechaEndFinal,
      tags: this.props.filters.tags,
      workingShiftGroup: this.props.filters.workingShiftGroup
    });
  };

  colorSeverityItem = severety => {
    // condition to define the color as defined in the api
    if (severety == null) {
      return 'gris';
    } else if (severety.toUpperCase() === 'BAD' || severety.toUpperCase() === 'WORSE') {
      return 'red';
    } else if (severety.toUpperCase() === 'GOOD' || severety.toUpperCase() === 'BETTER') {
      return 'green';
    }
    return 'yellow';
  };

  render() {
    // the setting object is obtained which we use for the configuration
    const obj = JSON.parse(this.props.setting.value);
    const permits = localStoreFN().getItem('permits');
    
    const setting = ObjGeneral.getSetting({
      setting: obj.summaryFFD,
      filter: this.props.filter,
      general: obj.generalSetting
    });
    
    // condition done to see if the setting was done
    if (this.props.setting) {
      const header = (
        <Header
          select={this.state.select}
          handleSubmit={this.handleSubmit}
          language={this.props.language}
          filter={setting.filter}
          filterWorkingShiftGroups={this.props.filterWorkingShiftGroups}
          date={this.props.dateMax[6]}
          filters={this.props.filters}
          loadingFilter={this.props.loadingFilter}
          loadingWorkingShiftGroups={this.props.loadingWorkingShiftGroups}
          defaultRangeInDay={obj.ffd.defaultRangeInDay}
        />
      );
      let container = '';
      // condition performed for loading state of the view
      if (this.props.loading 
        || this.props.loadingTable 
        || this.props.loadingFilter 
        || this.props.loadingCount) {
        container = <Loading language={this.props.language} />;
        // the 401 status of the application Expired token or unauthorized
      } else if (
        this.props.status === 401 ||
        this.props.statusTags === 401 ||
        this.props.statusTable === 401 ||
        this.props.statusCount === 401
      ) {
        container = <Expired history={this.props.history} />;
        // the status 200 of the application success
      } else if (
        this.props.status === 200 &&
        this.props.statusTags === 200 &&
        this.props.statusTable === 200 &&
        this.props.statusCount === 200
      ) {
        container = (
          <div className={"main-container scroll common-dashboards common-summary-container summary-ffd-sleep " + 
            this.colorSeverityItem(this.props.datos.mainKpi.value.type)}>
            <ButtonsTop
              language={this.props.language ? this.props.language : ''}
              filters={this.props.filters}
              handleSubmit={this.handleSubmit}
              reportType={this.props.filters.reportType}
              handleSubmitChangeFfdType={this.handleSubmitChangeFfdType}
              activeViews={obj.generalSetting.views}
              permits={permits}
            />
            <Main
              link={this.link}
              datos={this.props.datos}
              title={this.props.language}
              tooltip={this.props.language}
              graphColorRange={obj.graphColorRange.fatigueRiskPercentage}
              ffd={obj.ffd}
              language={this.props.language}
              reportType={this.props.filters.reportType}
            />
            <Buttons
              group={setting.group}
              selectGroup={this.state.select}
              language={this.props.language ? this.props.language : ''}
              handleSubmit={this.handleSubmitTable}
              handleDownloadExcelSummary={this.handleDownloadExcelSummary}
              handleDownloadExcelNoProcess={this.handleDownloadExcelNoProcess}
              reportType={this.props.filters.reportType}
            />
            <Table
              pag={this.state.pag}
              BPM={this.state.datosBPM}
              ffd={obj.ffd}
              tooltip={this.props.language.detail_fatigue.graphToolTip}
              datos={this.props.datosTable}
              title={this.props.language}
              main={this.state.select}
              language={this.props.language}
              handleSort={this.handleSort}
              loadingTable={this.props.loadingTableSpiner}
              loadingBPM={this.props.loadingBPM}
              count={this.props.count}
              reportType={this.props.filters.reportType}
              filters={this.props.filters}
              date={this.props.dateMax[6]}
              sort={this.state.sort}
            />
            <Tooltip placement="top" id="pageTooltip" />
          </div>
        );
      } else if (
        this.props.status === 500 ||
        this.props.statusTags === 500 ||
        this.props.statusTable === 500 ||
        this.props.statusCount === 500
      ) {
        container = <Message message={this.props.language.error.apiError500} />;
      } else {
        container = <Message message={this.props.language.error.apiError} />;
      }
      return (
        <section className="main" onScroll={this.handleScroll}>
          {header}
          {container}
        </section>
      );
    }

    return (
      <section className="main">
        <Message message="NO Setting" />
      </section>
    );
  }
}
const mapStateToProps = state => ({
  filter: state.reducer.tags.filter,
  statusTags: state.reducer.tags.status,
  loadingFilter: state.reducer.tags.loading,

  filterWorkingShiftGroups: state.reducer.workingShiftGroups.filter,
  statusWorkingShiftGroups: state.reducer.workingShiftGroups.status,
  loadingWorkingShiftGroups: state.reducer.workingShiftGroups.loading,

  setting: state.reducer.dashboard.setting,

  count: state.reducer.summaryFfdSleep.count,
  statusCount: state.reducer.summaryFfdSleep.statusCount,
  datos: state.reducer.summaryFfdSleep.datos,
  loading: state.reducer.summaryFfdSleep.loading,
  status: state.reducer.summaryFfdSleep.status,
  datosTable: state.reducer.summaryFfdSleep.datosTable,
  loadingTable: state.reducer.summaryFfdSleep.loadingTable,
  statusTable: state.reducer.summaryFfdSleep.statusTable,
  loadingTableSpiner: state.reducer.summaryFfdSleep.loadingTableSpiner,
  filters: state.reducer.summaryFfdSleep.filters,
  loadingBPM: state.reducer.summaryFfdSleep.loadingBPM,
  datosBPM: state.reducer.summaryFfdSleep.datosBPM,
  statusBPM: state.reducer.summaryFfdSleep.statusBPM,

  dateMax: state.reducer.dashboard.dateMax,
  language: state.reducer.dashboard.language,

  redirectPvt: state.reducer.summaryFfdPvt.active,
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(summaryFfdSleepActions, dispatch),
  ffdPvtActions: bindActionCreators(summaryFfdPvtActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch),
  workingShiftGroupsActions: bindActionCreators(workingShiftGroupsActions, dispatch),
  headerActions: bindActionCreators(headerActions, dispatch)
});
SummaryFfdSleep.propTypes = {
  datos: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object
  ]).isRequired,
  actions: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  history: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SummaryFfdSleep);



// WEBPACK FOOTER //
// ./source/client/containers/summary_ffd_sleep/index.jsx